import vidsecure_img from "../assets/images/vidsecure.png";
import ftdes_img from "../assets/images/FTDES_Power_BI.png";
import hasdrubal_img from "../assets/images/hasdrubal.png";
import isamm_img from "../assets/images/ISAMM_Site.png";
import facture_img from "../assets/images/billing.png";

export const my_builds = [
  {
    company: "Tritux Group",
    name: "VidSecure Platform",
    description: `
      A powerful streaming DRM solution that protects video content and enhances user experience. It includes advanced DRM technologies, optimized streaming and downloads, a notification system, and user interaction tracking.
    `,
    image_url: vidsecure_img,
    techs: ["Angular", "Spring Boot", "PostgreSQL", "Docker"],
    github_url: null,
    live_url: "https://github.com/FarahDvp/Streaming-DRM-Management",
  },
  {
    company: "FTDES",
    name: "Power BI Reporting Optimization",
    description: `Optimized Power BI reporting by streamlining data migration processes and designing interactive, dynamic reports that enhanced data visualization and delivered actionable insights for stakeholders.`,
    image_url: ftdes_img,
    techs: [
      "Power BI",
      "MongoDB",
    ],
    github_url: null,
    live_url: "https://al-forum.org/en/distribution-of-arrivals-of-tunisian-citizens-in-italy/",
  },
  {
    company: "Hasdrubal Foundation",
    name: "Artworks Management Website",
    description: `The Artworks Management Website helps museums, galleries, and collectors efficiently manage, archive, and preserve artwork data. It offers secure storage, advanced search, real-time updates, and detailed profiles for each piece, ensuring seamless management and data protection.`,
    image_url: hasdrubal_img,
    techs: [
      "React",
      "Redux",
      "Node.js",
      "Express",
      "MongoDB",
    ],
    github_url: null,
    live_url: "https://github.com/FarahDvp/ArtCollection",
  },
  {
    company: "ISAMM",
    name: "Management University Website",
    description: `A comprehensive platform for educational institutions, covering student, teacher, and alumni management, academic year creation, data import, and internship/project tracking.`,
    image_url: isamm_img,
    techs: ["React", "NestJS", "Express", "MongoDB", "Cypress"],
    github_url: null,
    live_url: "https://github.com/FarahDvp/Internship-Tracking-Platform",
  },
  {
    company: "INNOVUP",
    name: "Billing Website",
    description: `A website for the company to manage their quotes and invoices seamlessly.`,
    image_url: facture_img,
    techs: [
      "Angular",
      "Node.js",
      "Express",
      "MongoDB",
    ],
    github_url: null,
    live_url: "https://drive.google.com/drive/folders/10tF-euu9wB_9QQ45crAsevJhkq-DsL-G",
  },
];
